import React, { useMemo, useState } from "react";
import "./Cards.scss";
import deliver from "../../img/service-deliver.jpg";
import buy from "../../img/service-buy.jpg";
import trip from "../../img/service-trip.jpg";
import production from "../../img/service-production.jpg";
import outsourcing from "../../img/service-delivery-Ru.jpg";
import money from "../../img/service-money.jpg";
import declaration from "../../img/service-declaration.jpg";
import stock from "../../img/service-stock.jpg";
import search from "../../img/service-search.jpg";

function toParagraphs(text = "") {
	const parts = text.split(/\n+/).map(s => s.trim()).filter(Boolean);
	return parts.map((p, i) => <p key={i}>{p}</p>);
}

function CardItem({ item }) {
	const [expanded, setExpanded] = useState(false);

	const preview = useMemo(() => {
		const t = (item.text || "").replace(/\s+/g, " ").trim();
		return t.length > 220 ? t.slice(0, 220) + "…" : t;
	}, [item.text]);

	return (
		<article
			className={`card-body ${expanded ? "is-expanded" : ""}`}
			aria-expanded={expanded}
			data-keywords={(item.keywords || []).join(",")}
		>
			<div className="img-wrapper">
				<img src={item.img} alt={item.title} loading="lazy" />
			</div>

			<h3 className="card-title">{item.title}</h3>

			{!expanded && <p className="card-preview" title={preview}>{preview}</p>}

			{expanded && (
				<div className="card-content">
					{toParagraphs(item.text)}
				</div>
			)}

			<div className="card-actions">
				<button
					type="button"
					className="readmore-btn"
					onClick={() => setExpanded(v => !v)}
					aria-controls={`content-${item.id}`}
				>
					{expanded ? "Свернуть" : "Подробнее"}
				</button>
			</div>
		</article>
	);
}

function Cards() {
	const services = [
		{
			id: 1,
			img: deliver,
			title: "Международные грузоперевозки",
			text:
				"Наша компания AIDADECK Logistics специализируется на международных грузоперевозках любых типов: от мелких партий до крупногабаритных грузов. Мы предлагаем оптимальные маршруты, тщательно продумываем логистику — морской, автомобильный и железнодорожный транспорт. Документальное сопровождение, таможенное оформление и страхование груза — всё в одном месте.\n" +
				"Мы гарантируем точные сроки доставки, минимальные риски и прозрачную стоимость услуг. Если вам нужны надежные партнёры в логистике, обращайтесь к нам — мы обеспечим полный комплекс услуг высокого качества.",
			keywords: [
				"международные грузоперевозки",
				"оптимальные маршруты",
				"доставка груза",
				"документальное сопровождение",
				"надёжные партнёры",
			],
		},

		{
			id: 2,
			img: outsourcing,
			title: "Автомобильные перевозки и доставка по России",
			text:
				"Если вы ищете надёжные автомобильные перевозки по России, AIDADECK Logistics — ваш партнёр. Мы осуществляем доставку грузов всеми видами автотранспорта: фуры, полу-прицепы, рефрижераторы. Обеспечиваем сквозной контроль, страхование, соблюдение графиков маршрутов.\n" +
				"Мы покрываем основные магистральные и региональные направления, работаем с срочными доставками, распределяем грузы по оптимальным маршрутам и минимизируем издержки. Наша цель — чтобы ваш груз прибыл вовремя, в целости и с минимальными затратами.",
			keywords: [
				"автомобильные перевозки",
				"доставка по России",
				"рефрижераторы",
				"срочные перевозки",
				"надёжность и соблюдение сроков",
			],
		},

		{
			id: 3,
			img: stock,
			title: "Складские услуги и хранение",
			text:
				"AIDADECK Logistics предлагает профессиональные складские услуги и хранение грузов. Наши склады оборудованы всем необходимым для сохранности товара: температурный контроль, системы безопасности, разделение по зонам.\n" +
				"Мы организуем приём, учёт, упаковку и маркировку продукции, обеспечиваем быструю обработку поступлений и выдачу. Для тех, кто работает с крупными объёмами — индивидуальные решения по складской логистике. AIDADECK гарантирует качество хранения, сохранность и точность при выполнении всех операций.",
			keywords: [
				"складские услуги",
				"хранение грузов",
				"температурный контроль",
				"упаковка и маркировка",
				"складская логистика",
			],
		},

		{
			id: 4,
			img: declaration,
			title: "Таможенное оформление и страхование",
			text:
				"Компания AIDADECK Logistics предлагает полный спектр услуг таможенного оформления. Мы помогаем клиентам правильно подготовить импортные и экспортные декларации, соблюдая все нормы и правила. Также предоставляем услуги страхования грузов, что позволяет защитить ваши вложения от непредвиденных обстоятельств.\n" +
				"Наши специалисты следят за изменениями в законодательстве, оформляют сертификаты и разрешения, предлагают выгодные тарифы на страхование и минимизируют дополнительные расходы. Если вы хотите избежать задержек на границе и неприятных сюрпризов — таможенное сопровождение и страхование грузов от AIDADECK-Logistics — это ваш выбор.",
			keywords: [
				"таможенное оформление",
				"импортные декларации",
				"экспортные декларации",
				"страхование грузов",
				"законодательно-нормативные требования",
			],
		},

		{
			id: 5,
			img: buy,
			title: "Выкуп товаров",
			text:
				"0% комиссия за выкуп с 1688 и других площадок и 0% комиссия за оплату поставщику по лучшему курсу.\n" +
				"Проверяем продавцов, согласуем упаковку и маркировку, запрашиваем фото/видео и образцы, фиксируем условия по срокам и MOQ.",
			keywords: [
				"выкуп 1688",
				"оплата поставщику",
				"лучшая конвертация CNY",
				"проверка поставщика",
			],
		},

		{
			id: 6,
			img: search,
			title: "Поиск производителей и поставщиков в Китае",
			text:
				"От детских игрушек до промышленных станков — подберём проверенных поставщиков под ваши требования и бюджет.\n" +
				"Сверим спецификации, запросим образцы, организуем инспекцию и консолидацию.",
			keywords: [
				"поиск поставщиков",
				"проверка фабрик",
				"инспекция качества",
			],
		},

		{
			id: 7,
			img: production,
			title: "Контрактные производства",
			text:
				"Поможем создать уникальный продукт под вашим брендом: ODM/OEM, упаковка, маркировка, контроль качества и запуск партии.\n" +
				"Сопровождаем проект от прототипа до серийного выпуска.",
			keywords: [
				"контрактное производство",
				"ODM OEM",
				"частная марка",
				"контроль качества",
			],
		},

		{
			id: 8,
			img: money,
			title: "Трансфер денег",
			text:
				"Мы переводим деньги в банк в Китае и далее напрямую поставщику товара в юанях, контролируя поступления денежных средств на каждом этапе проведения транзакций.\n" +
				"Готовим подтверждающие документы для бухгалтерии и таможни, согласуем графики оплат и фиксируем курс.",
			keywords: [
				"перевод в юанях",
				"платежи в КНР",
				"контроль поступлений",
				"подтверждающие документы",
			],
		},

		{
			id: 9,
			img: trip,
			title: "Поездки в Китай",
			text:
				"Для бизнесменов, дорожащих своим временем и финансовыми ресурсами, наша компания предлагает услуги переводчика в Китае.\n" +
				"Организуем посещение фабрик и выставок, помогаем с переговорами и протоколами встреч.",
			keywords: [
				"переводчик в Китае",
				"посещение фабрик",
				"деловые поездки",
			],
		},
	];

	return (
		<div className="card-wrapper">
			<h1>Наши услуги</h1>
			<div className="cards">
				{services.map(item => (
					<CardItem key={item.id} item={item} />
				))}
			</div>
		</div>
	);
}

export default Cards;
